'use strict';
import CryptoJS from 'crypto-js'

const symbolMap = {
  '/': 'xjxw2xa',
  '+': 'xmnw1ak',
  '=': '15sd2az'
};
function encodeSymbols(str) {
    return str.replace(/[\/+=]/g, (match) => symbolMap[match] || match);
}
function decodeSymbols(str) {
  return str
    .replace(/xjxw2xa/g, '/')
    .replace(/xmnw1ak/g, '+')
    .replace(/15sd2az/g, '=');
}

const aesEncrypt = (content) => {
    const parsedkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_PASSWORD_ENCRYPT);
    const iv = CryptoJS.enc.Utf8.parse('test');
    const encrypted = CryptoJS.AES.encrypt(content, parsedkey, { iv: iv, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
};

// const aesDecrypt = (word) => {
//     var keys = CryptoJS.enc.Utf8.parse(process.env.PASSWORD_ENCRYPT);
//     let base64 = CryptoJS.enc.Base64.parse(word);
//     let src = CryptoJS.enc.Base64.stringify(base64);
//     var decrypt = CryptoJS.AES.decrypt(src, keys, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
//     return JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
// };

const aesEncryptIdentitas = (content) => {
    try {
        if(content != ""){
            const parsedkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_PASSWORD_ENCRYPT);
            const iv = CryptoJS.enc.Utf8.parse('identitas');
            const encrypted = CryptoJS.AES.encrypt(content, parsedkey, { iv: iv, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
            const encodeSymbol = encodeSymbols(encrypted.toString())

            return encodeSymbol;
        } else {
            return content
        }
    } catch (error) {
        console.log("aesEncrypt = ", error)
    }

};

const aesDecryptIdentitas = (content) => {
    try {
        if(content != ""){
            if(content === null || content === undefined){
                return ""
            } else {
                const decodeSymbol = decodeSymbols(content)
                const parsedkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_PASSWORD_ENCRYPT);
                const iv = CryptoJS.enc.Utf8.parse('identitas');
                const decrypted = CryptoJS.AES.decrypt(decodeSymbol, parsedkey, { iv: iv, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });

                return decrypted.toString(CryptoJS.enc.Utf8)
            }
        } else {
            return content
        }
    } catch (error) {
        console.log("aesDecrypt = ", error)
    }


};



export default {aesEncrypt, aesEncryptIdentitas, aesDecryptIdentitas};
